import { CustomerWidgetFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/customer-widget/catalog";
import { CustomerWidgetFlatTeamSettingGroups } from "../../flat-team-settings/customer-widget/groups";
import { ExchangeAgentGuidanceFlatTeamSettingGroups } from "../../flat-team-settings/exchange-agent-guidance/groups";
import { FulfillmentFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/fulfillment/catalog";
import { FulfillmentFlatTeamSettingGroups } from "../../flat-team-settings/fulfillment/groups";
import { ReturnsBillingGeneralFlatTeamSettingGroups } from "../../flat-team-settings/returns-billing-general/groups";
import { ReturnsFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/returns/catalog";
import { ReturnsFlatTeamSettingGroups } from "../../flat-team-settings/returns/groups";
import { SupportFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/support/catalog";
import { SupportFlatTeamSettingGroups } from "../../flat-team-settings/support/groups";
import { WarrantyRegistrationRewardsFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/warranty-registration-rewards/catalog";
import { WarrantyRegistrationRewardsFlatTeamSettingGroups } from "../../flat-team-settings/warranty-registration-rewards/groups";
import { WarrantyRegistrationFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/warranty-registration/catalog";
import { WarrantyRegistrationFlatTeamSettingGroups } from "../../flat-team-settings/warranty-registration/groups";
import { defineSettingsProvider } from "../provider";
import type { SettingDefinition, SettingGroupDefinition } from "../types";

export const FlatTeamSettingsCatalogProvider = defineSettingsProvider({
  name: "flat team settings",
  groups: [
    ...CustomerWidgetFlatTeamSettingGroups,
    ...FulfillmentFlatTeamSettingGroups,
    ...ReturnsFlatTeamSettingGroups,
    ...SupportFlatTeamSettingGroups,
    ...ExchangeAgentGuidanceFlatTeamSettingGroups,
    ...ReturnsBillingGeneralFlatTeamSettingGroups,
    ...WarrantyRegistrationFlatTeamSettingGroups,
    ...WarrantyRegistrationRewardsFlatTeamSettingGroups,
  ],
  definitions: [
    ...CustomerWidgetFlatTeamSettingCatalogDefinitions,
    ...FulfillmentFlatTeamSettingCatalogDefinitions,
    ...ReturnsFlatTeamSettingCatalogDefinitions,
    ...SupportFlatTeamSettingCatalogDefinitions,
    ...WarrantyRegistrationFlatTeamSettingCatalogDefinitions,
    ...WarrantyRegistrationRewardsFlatTeamSettingCatalogDefinitions,
  ],
});

export const FlatTeamSettingsCatalogGroups =
  FlatTeamSettingsCatalogProvider.groups satisfies readonly SettingGroupDefinition[];

export const FlatTeamSettingsCatalogDefinitions =
  FlatTeamSettingsCatalogProvider.definitions satisfies readonly SettingDefinition[];
